import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const LanguageArtsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_7_"
        x1="427.88"
        x2="491.433"
        y1="66.614"
        y2="66.614"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="10.91"
        y="21.49"
        width="67.76"
        height="67.4"
        rx="15.68"
        transform="translate(-10.25 10.22) rotate(-11.69)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_7_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(14 35) rotate(-12.23)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_6_"
        x1="487.929"
        x2="555.452"
        y1="108.183"
        y2="108.183"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="90.35"
        y="6.13"
        width="66.77"
        height="66.41"
        rx="15.68"
        transform="translate(-1.27 4.25) rotate(-1.96)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_6_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(97 14) rotate(-1.96)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_5_"
        x1="564.252"
        x2="639.061"
        y1="130.613"
        y2="130.613"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="178.62"
        y="7.75"
        width="66.22"
        height="65.88"
        rx="15.68"
        transform="translate(11.99 -40.5) rotate(11.24)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_5_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(191 10) rotate(11.24)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_8_"
        x1="478.175"
        x2="548.883"
        y1="227.51"
        y2="227.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="47.52"
        y="92.09"
        width="66.14"
        height="65.79"
        rx="15.68"
        transform="translate(-23.65 18.92) rotate(-11.69)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_8_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(50 105) rotate(-11.69)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_3_"
        x1="549.091"
        x2="619.798"
        y1="218.327"
        y2="218.327"
        gradientTransform="rotate(16.219 592.677 222.333)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="128.57"
        y="86.51"
        width="65.22"
        height="64.88"
        rx="15.68"
        transform="translate(0.74 -1) rotate(0.35)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_3_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(135.5, 92.5) rotate(0.35)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_4_"
        x1="629.318"
        x2="691.327"
        y1="232.946"
        y2="232.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#D52BC8" />
        <stop offset="0.984" stopColor="#C42BC8" />
      </linearGradient>
      <rect
        x="208.71"
        y="89.27"
        width="65.22"
        height="64.88"
        rx="15.68"
        transform="translate(0.76 -1.49) rotate(0.35)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_4_)"
      />
      <image
        width="52"
        height="52"
        transform="translate(215.5, 95.5) rotate(0.35)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-language-art"
      transform="translate(390, 130)"
    >
      <defs>
        <linearGradient
          id="abf33d1e-3a8e-4517-aab3-b1e30e04216e"
          x1="245.57"
          y1="236.33"
          x2="213.47"
          y2="603.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#663d3c" />
          <stop offset="0.01" stopColor="#663d3c" />
          <stop offset="0.32" stopColor="#794545" />
          <stop offset="0.64" stopColor="#834a4a" />
          <stop offset="1" stopColor="#874c4c" />
        </linearGradient>
        <linearGradient
          id="b2240fb7-7bd6-47ec-8aeb-737a8aae1db9"
          x1="362.41"
          y1="242.47"
          x2="354.89"
          y2="328.62"
          href="#abf33d1e-3a8e-4517-aab3-b1e30e04216e"
        />
        <linearGradient
          id="ecbe2cd4-e0d1-4e17-b818-b75182920eaa"
          x1="382.35"
          y1="166.07"
          x2="357.9"
          y2="445.99"
          href="#abf33d1e-3a8e-4517-aab3-b1e30e04216e"
        />
        <linearGradient
          id="fa90d4e2-a273-4372-84ac-bf9f2e819f13"
          x1="93.78"
          y1="207.6"
          x2="89.66"
          y2="360.72"
          href="#abf33d1e-3a8e-4517-aab3-b1e30e04216e"
        />
        <linearGradient
          id="afc121e7-73c0-4042-9f3c-c50fc44adbec"
          x1="190.59"
          y1="250.03"
          x2="160.5"
          y2="594.53"
          href="#abf33d1e-3a8e-4517-aab3-b1e30e04216e"
        />
        <linearGradient
          id="eb905d2d-aaa3-41bd-8f87-c5d122573445"
          x1="296.67"
          y1="246.84"
          x2="273.62"
          y2="510.77"
          href="#abf33d1e-3a8e-4517-aab3-b1e30e04216e"
        />
      </defs>
      <g id="fb0d34bd-b7c3-4877-be91-ee71af73773a" data-name="island5">
        <g>
          <polygon
            points="291.96 334.3 256.77 400.42 214.11 353.5 291.96 334.3"
            fill="#874c4c"
          />
          <path
            d="M7.52,198.65S36.23,250.46,52.31,274c5.39,7.9,10.76-6.59,11.35-4.12.5,2.1,6.79,17.25,12.54,21.79,11.92,9.41,32.86,26.51,47.19,25.92a80.25,80.25,0,0,1,18.77,15.23l18.78,52.86L200.78,367,322.89,343.9l13.86-39.46,25.6-2.13s41.77-99.79,41.19-102.48S378,155.45,378,155.45l-78.5,94.23s14.81,41.8,11.31,42.7-105.2-20.58-114.55-27.74-4.67-13.43-4.67-13.43-19.87-8.94-36.24-9.84-29.8-26.84-40.32-35.79S87,202,73.54,209.16,46.66,211,47.83,202.89,7.52,198.65,7.52,198.65Z"
            fill="#874c4c"
          />
          <polygon
            points="363.42 277.78 393.28 277.78 405.01 196.73 364.46 205.95 363.42 277.78"
            fill="#874c4c"
          />
          <polygon
            points="249.3 290.57 254.64 384.42 218.38 295.91 249.3 290.57"
            fill="url(#abf33d1e-3a8e-4517-aab3-b1e30e04216e)"
          />
          <polygon
            points="359.15 276.71 357.02 255.38 365.55 255.38 359.15 276.71"
            fill="url(#b2240fb7-7bd6-47ec-8aeb-737a8aae1db9)"
          />
          <path
            d="M355.93,252.16c4.29,1.09,13.88,2.16,14.95,9.62s1.76,15.62,1.76,15.62l24.9-68.94Z"
            fill="url(#ecbe2cd4-e0d1-4e17-b818-b75182920eaa)"
          />
          <path
            d="M72.62,229.27c9.56-5.3,16.13-7.66,23.29,1.77s8.37,73.62,14.94,81.86c4.18,4.72-13.14,1.18-25.69-16.49S72.62,229.27,72.62,229.27Z"
            fill="url(#fa90d4e2-a273-4372-84ac-bf9f2e819f13)"
          />
          <path
            d="M160.79,385.49l29.5-84.95s1.78,61.16,8.05,66.47C186.15,374.32,160.79,385.49,160.79,385.49Z"
            fill="url(#afc121e7-73c0-4042-9f3c-c50fc44adbec)"
          />
          <path
            d="M282.36,351.36c4.48-16.78-9.09-64.91-9.09-64.91l17.92-1.37L308,346Z"
            fill="url(#eb905d2d-aaa3-41bd-8f87-c5d122573445)"
          />
          <path
            d="M97.48,248.45c-.33-3.88.12-7.86-1-11.62-3.64-12.29-17.3-7.94-29.89-2.49-6.32,2.73-16.78-.84-23.46,1s-15.47.17-17.88-5.82c-.83-2.06-.78-4.32-1.46-6.42-1.4-4.32-5.57-7.3-8.82-10.69C8.64,205.86,5.49,197.3,2.49,189c-1.34-3.72-2.7-7.55-2.46-11.45.6-10,10.88-16.84,20.14-22.18,16.77-9.65,2.26-19.89,19-29.55,19.73-11.36,77.27-7.9,100.49-9.92,25.51-2.23,45-7,70.59-6.54,23.18.45,46.87-6.66,69.19-.88,8.75,2.27,55.63,7.27,63.54,11.39,18.09,9.4,35.66,14.41,53.75,23.82,11.49,6-14.9,15.62-1.72,16.54,4.29.3,8.81.08,12.64,1.87,7,3.25,8.72,11.79,7.35,18.82s-5,13.66-5.54,20.79c-.23,2.81,0,5.82-1.56,8.26-4.09,6.47-17.56,5-19.38,12.33-.7,2.81.86,6-.62,8.53-2.35,4.06-11.32,6.53-7.91,9.91.81.8,2.08,1,3.16,1.48,6,2.53,3.72,11.71-2.26,14.25s-12.94.78-19.33-.71-13.78-2.51-19,1.12c-2.9,2-4.95,5.31-8.49,6.06-2.13.46-4.36-.15-6.55-.1-8,.21-12.31,8.42-14.85,15.33l35.87,8c4.61,1,6.66,6.43-3.67,9.49s-21.4,3.16-32.27,3.23c-48.1.3-98.08,4.19-146,.07C139.14,296.61,99.85,276.27,97.48,248.45Z"
            fill="#68c902"
          />
          <path
            d="M101,237.47c-10.54-4.73-14.88-1.52-12.09,1.22S114.13,243.36,101,237.47Z"
            fill="#68c902"
          />
          <path
            d="M36.09,239.19l.53-1.24c.55,1.73,3.58,1.79,4.2.08.78,1.36,2.35,2.94,3.66,2.05.35-.24.59-.63.93-.88,1.13-.85,2.75.07,3.69,1.12s1.91,2.36,3.33,2.41a6.7,6.7,0,0,0,.69-4.82,15.72,15.72,0,0,0,4.06,2.89,13.47,13.47,0,0,0,.93-3.59c.86,1.95,3.76,1.5,5.76.72l8.4-3.26a38.42,38.42,0,0,1,3.89,8.68c-.8-3.93-1.26-8.79,2-11.17a41.57,41.57,0,0,0,.67,8.41c5.09-4.83,4.91-12.76,4.37-19.7a84.1,84.1,0,0,0-8.89,2.81,108,108,0,0,1-16.92,3.56l-19.81,3.09c-2.07.32-6.12.15-6.54,2.87C30.79,234.83,34.44,239.19,36.09,239.19Z"
            fill="#68c902"
          />
          <ellipse cx="251.81" cy="281.2" rx="28.67" ry="7.36" fill="#54ba02" />
          <path
            d="M251.81,273.84c-13.82,0-25.36,2.51-28.07,5.85,4.89-2.26,14.29-3.79,25.09-3.79,15.83,0,28.67,3.29,28.67,7.36a2.33,2.33,0,0,1-.61,1.5c2.29-1.05,3.59-2.27,3.59-3.56C280.48,277.13,267.65,273.84,251.81,273.84Z"
            fill="#4fb002"
          />
          <ellipse
            cx="205.62"
            cy="288.86"
            rx="16.44"
            ry="4.22"
            fill="#54ba02"
          />
          <path
            d="M205.62,284.63c-7.93,0-14.54,1.45-16.09,3.36,2.8-1.3,8.19-2.17,14.38-2.17,9.08,0,16.44,1.89,16.44,4.22a1.36,1.36,0,0,1-.35.86c1.31-.61,2.06-1.3,2.06-2C222.06,286.52,214.7,284.63,205.62,284.63Z"
            fill="#4fb002"
          />
          <ellipse
            cx="344.59"
            cy="236.24"
            rx="19.91"
            ry="5.11"
            fill="#54ba02"
          />
          <path
            d="M344.59,231.13c-9.6,0-17.61,1.74-19.49,4.07,3.4-1.58,9.92-2.64,17.42-2.64,11,0,19.91,2.29,19.91,5.11a1.7,1.7,0,0,1-.42,1.05c1.59-.74,2.49-1.58,2.49-2.48C364.5,233.42,355.59,231.13,344.59,231.13Z"
            fill="#4fb002"
          />
          <ellipse cx="314.48" cy="230.5" rx="10.51" ry="2.7" fill="#54ba02" />
          <path
            d="M314.48,227.8c-5.07,0-9.3.92-10.29,2.15,1.79-.83,5.24-1.4,9.19-1.4,5.81,0,10.52,1.21,10.52,2.7a.92.92,0,0,1-.22.56c.83-.39,1.31-.84,1.31-1.31C325,229,320.29,227.8,314.48,227.8Z"
            fill="#4fb002"
          />
          <path
            d="M61.62,254.74s-8.36-.39-9.76,1-9.16.39-9.16.39l-1.19-4.71a52.19,52.19,0,0,0-3.38,4.51c-.2.59-1,3.14-1,3.14L38.92,265l1.2-4.51,3,.78a23.63,23.63,0,0,1,.8,3.14c0,.59,1.59-3.33,1.59-3.33l2.59,1,1-2.36,2,1.38.59,4.12,1.8-6.28,1.39,1.37L56,258.08l1.8-1Z"
            fill="#45a102"
          />
          <path
            d="M193.49,316.88l3.73,2.68,7.44.21L222,317.91s-6.58,3.3-7.18,3.45-11.49.89-11.49.89l-2.84,3.1-1.56-3-1.46-.26-.8,4-1.8-4.8-2.79,1.7-.4-3.09Z"
            fill="#45a102"
          />
          <path
            d="M204.17,298.68c5.41,1.29,12.23-.66,17.78-.35,4,.22,7-.29,11.05-.59,28.26-2.11,56.2-.76,84.46-2.87,6-.44,12-.88,17.87.19,1.4.26,3.16,1.17,2.78,2.52-.28,1-1.55,1.31-2.59,1.44l-18,2.18a7,7,0,0,1-3.45,6.26,21.34,21.34,0,0,0,.16-6.23A35.78,35.78,0,0,1,304,302l-2.4-.07L287,301.5l1.23,2.41a29.46,29.46,0,0,0-19.86-.63,40,40,0,0,1,9.34,3.55,33,33,0,0,1-19.21-4,6.13,6.13,0,0,1-6.72,1.19,5.54,5.54,0,0,1-8.33-1l-.81,10.57a24.88,24.88,0,0,1-4.41-11.77,6.48,6.48,0,0,1-7,1.87,27.07,27.07,0,0,1-17.82-1c-3.69-1.51-6.67-4.14-10.64-5-5.94-1.22-12.43.5-18.51-.07a129.6,129.6,0,0,1-17.91-3.36c-8.31-2-19.94-6.32-28.44-4.29.28,2.84,2.63,5.42,5.25,6.54,1,.43,2.66.28,2.61-.8.58,1.47,1.28,3.07,2.7,3.8s3.68-.17,3.52-1.75c3.55,3.09,9.06,4.59,13.06,2.1a6,6,0,0,0,8.24,1.66L177,309a26,26,0,0,0,3.76-8.29,3.53,3.53,0,0,0,5.26,1.23c1.58,2.56,4.91,3.65,7.94,3.44s5.87-1.51,8.62-2.78l1,4.64c1.51-1.31,2.9-3.06,2.78-5a3.83,3.83,0,0,0-.55-1.78"
            fill="#68c902"
          />
          <path
            d="M328.45,272a13.68,13.68,0,0,0-4.26-4.5l9.28-1.2-3.85-1.42a47.5,47.5,0,0,0,22.72-2,43.52,43.52,0,0,0-10.54-2.68,16.11,16.11,0,0,1,11.89-2.64c2.84.5,6.47,1.47,8-.91l5.44,1.73c.57-.88-.34-2-1.19-2.57-7-5-16.28-6.43-24.84-5s-16.46,5.52-23.48,10.55a11.9,11.9,0,0,0-3.14,2.94c-1.69,2.61-4.75,12.46.64,12.78,3.16.19,2.65-3.22,4.26-4.34C320,272.35,327.88,271,328.45,272Z"
            fill="#68c902"
          />
          <path
            d="M51.77,121.66a6.4,6.4,0,0,0,2.67-3,6.07,6.07,0,0,0,7.11,1.42,5.9,5.9,0,0,0,3-6.52l2.87,9.21c5.27-6.4,12.47-13.51,20.59-11.54a7,7,0,0,0-7.72,6.16,12.34,12.34,0,0,1,9.15.52,4,4,0,0,0,2.46-2.25c.93,2.14,4.6,1.33,5.5-.82s0-4.59-.9-6.75a23.93,23.93,0,0,1,9,10.68l5.49-3.41c-1.25,1.17,1.79,2.08,3.22,1.13s4.44-.84,3.69.69a71.75,71.75,0,0,1,4.74-15.61A29.29,29.29,0,0,0,125,115.79a5.37,5.37,0,0,0,2.33-2.52c-.1,1.09,1.31,1.62,2.41,1.75A43,43,0,0,0,160,107l-3.83,6.83a32.17,32.17,0,0,1,19.11-2.34l.18-5.33,9.89,4.65,2.52-3.21a21,21,0,0,0,4.77,5.06c-2.14,3.53-7,4.18-11.12,4.42q-23.22,1.38-46.47,1.93c-18.45.43-37.08.55-55.27,4-8.79,1.65-17.61,6.65-26.17,7.86-7.91,1.12-11-6.53-7.68-13.45A13.68,13.68,0,0,1,51.77,121.66Z"
            fill="#68c902"
          />
          <path
            d="M200.11,107.83c.83.14,1.59.55,2.4.76,4.64,1.24,8.37-3.69,10.59-7.89l1.82,2.47a3.12,3.12,0,0,0,2.5-1l6.94,4.84a8.1,8.1,0,0,0,7.76-3.83c.06,2.8,3.86,4,6.56,3.2s4.91-2.86,7.61-3.69,6.51.43,6.55,3.23l3.12-1.43c-.92.56.45,1.81,1.53,1.79a8.66,8.66,0,0,0,7.71-5.23l4.61,5,3.39-2.24a6.73,6.73,0,0,0,3,3.55,17.49,17.49,0,0,1,7.88-9.6,28.26,28.26,0,0,0-3,10.51l3.45-2.73c2.16,1.86,1.07,5.66-1.34,7.21s-5.48,1.48-8.35,1.39q-25.09-.8-50.19,0c-7.29.22-16.32,2.21-23.46,1.13-2.37-.36-4.15.65-5.28-2.12C194.86,110.62,197.22,107.33,200.11,107.83Z"
            fill="#68c902"
          />
          <path
            d="M393.83,138l-3.34.94-1.31-2c.2,1.08-1.41,1.77-2.37,1.2a3.91,3.91,0,0,1-1.49-2.85,22.74,22.74,0,0,1,.05-8.06,17,17,0,0,0-4.07,7l-1.05-2-1.78.83c-2,.1-3.75-2.71-5.58-1.82-.44.21-.78.62-1.25.75-.71.19-1.39-.32-2-.76a19.14,19.14,0,0,0-10.3-3.83c3.4,5.69,9.67,9,15.76,11.79,4.36,2,25.23,13,24.62.73-.94,1-3,1.31-4,2.12C395.6,141.78,393.48,138.06,393.83,138Z"
            fill="#68c902"
          />
          <path
            d="M249.85,337.72c2.3.58,5.11-.48,5.85-2.74.33,2.45,4.11,3.47,5.62,1.52.78-1,1-2.54,2.16-3.07a5.63,5.63,0,0,1,2-.23,4.82,4.82,0,0,0,4.29-3.82l1.16,1.27c.77-1,2.35-1,3.56-.53a13.18,13.18,0,0,0,3.62,1.29,3.71,3.71,0,0,0,3.7-4.21,6.6,6.6,0,0,0,8.84-.94,14.33,14.33,0,0,1,.48,5.77,4.86,4.86,0,0,1-3.68,4c-1.62.24-3.46-.62-4.83.28-1,.67-1.3,2-1.69,3.21s-1.31,2.46-2.54,2.28a5,5,0,0,1-1.91-1.12c-2.48-1.66-5.76-.13-8.75-.09-2.76,0-5.74-1.22-8.16.13-1.47.82-2.59,2.55-4.27,2.49a4.46,4.46,0,0,1-2.62-1.38c-2.18-1.88-5.05-3.77-6.65-6.09A14.28,14.28,0,0,0,249.85,337.72Z"
            fill="#45a102"
          />
        </g>
      </g>
      <g id="bd55b179-1691-4833-8292-ad91f38b6223" data-name="decor 5">
        <ellipse cx="371.34" cy="192.52" rx="21.8" ry="10.7" fill="#55a32a" />
        <g>
          <path
            d="M60.39,194.39c-2.41,2.76-7.2,5-9.22,3.22s-.47-6.81,1.94-9.57,4.76-2.17,6.77-.41S62.79,191.64,60.39,194.39Z"
            fill="#e4f6fb"
          />
          <path
            d="M59.72,205.38c-3.62-.48-8.12-3.26-7.76-5.91s5.42-4.15,9-3.66,4.44,2.77,4.09,5.42S63.35,205.87,59.72,205.38Z"
            fill="#e4f6fb"
          />
          <path
            d="M49.54,209.32c-1.31-3.42-1-8.69,1.47-9.65s6.24,2.78,7.55,6.19-.32,5.23-2.81,6.18S50.84,212.73,49.54,209.32Z"
            fill="#e4f6fb"
          />
          <path
            d="M42.44,198.63c3.24-1.68,8.52-2,9.75.39s-2.06,6.5-5.31,8.19-5.23.27-6.45-2.1S39.19,200.31,42.44,198.63Z"
            fill="#e4f6fb"
          />
          <path
            d="M48.9,189.32c3,2.11,5.69,6.65,4.15,8.83s-6.72,1.18-9.71-.93-2.65-4.51-1.12-6.69S45.91,187.22,48.9,189.32Z"
            fill="#e4f6fb"
          />
          <circle cx="51.73" cy="198.43" r="3.87" fill="#feaf26" />
        </g>
        <path
          d="M314.31,185.07l4.46,6.89a12.65,12.65,0,0,1,.09-4.34l.89,1.76a11.37,11.37,0,0,0,1.84-2.46,8.32,8.32,0,0,0,.62,3.41c1.32-1.16,2.61-2.37,3.84-3.63l-.16,3.18a7.65,7.65,0,0,1,4.92-2.92,22.36,22.36,0,0,1,5.84-.12c-1.53-.47-2.88,1-3.76,2.38l-4.57,6.87a7.82,7.82,0,0,1,1-4.07l-1.81,2.28a1.29,1.29,0,0,0-2.11-.7l-1-1a2.08,2.08,0,0,1-2.35,2.15,2.81,2.81,0,0,1-2.23-2.6,14.06,14.06,0,0,1-1.78,4.16c-1-1.47-1.61-3.25-2.94-3.84C315,190.54,315.41,186.77,314.31,185.07Z"
          fill="#55a32a"
        />
        <path
          d="M177.55,169.18a10.35,10.35,0,0,1-.13-3.72l1.37,2a4,4,0,0,1,1.56-1.69,8.91,8.91,0,0,0,2.33,2.56l1.91-1.54a1.81,1.81,0,0,0,2.3,1.32,5.2,5.2,0,0,0,2.38-1.81l.9,2a6.46,6.46,0,0,0,2.22-1.37,2,2,0,0,0,.67,1.68,36.17,36.17,0,0,1,11.55-17.46,51.18,51.18,0,0,0-11.23,23.41,22.75,22.75,0,0,1,7-7.16,1.36,1.36,0,0,0,.07,2,102.18,102.18,0,0,1-7,12,34.62,34.62,0,0,0-3.53-10l-1.62,2.38a3.75,3.75,0,0,1-1.83-1.61,3.41,3.41,0,0,0-1.87-1.55c-.81-.17-1.8.59-1.51,1.37-1.35-1.21-2.67-2.53-4.11-3.6-.2,2.14.42,4.76-.32,6.75-3.28-2.72-3.89-9.87-5.83-13.58C174.4,164.06,176,166.62,177.55,169.18Z"
          fill="#55a32a"
        />
      </g>
      <g id="a86fc51f-496f-4440-a5c7-731cf6fe703e" data-name="flag abc">
        <g>
          <path
            d="M375.48,198.4c0,3.76-6.89,6.81-15.39,6.81s-15.4-3.05-15.4-6.81c0-.78.07-3.06.07-3.06s8.59-3.75,15.33-3.75,15.36,3.69,15.36,3.69S375.48,197.58,375.48,198.4Z"
            fill="#8abcf8"
          />
          <ellipse
            cx="360.09"
            cy="195.55"
            rx="15.39"
            ry="6.81"
            fill="#9ae1f8"
          />
          <path
            d="M359.59,193.85c1.27,1.16,12.62-2.73,12.62-2.73s-4.25-1.58-5-1.77a44.51,44.51,0,0,0-8.87,2.73Z"
            fill="#8aa6f8"
          />
          <path
            d="M360.29,194.56H357.8v-171L360.08,0l2.3,23.58V192.47A2.08,2.08,0,0,1,360.29,194.56Z"
            fill="#9ae1f8"
          />
          <path
            d="M360.08,0,359,10.86l1.26,12.91V194.56h0a2.08,2.08,0,0,0,2.09-2.09V23.58Z"
            fill="#8abcf8"
          />
          <rect
            x="323.53"
            y="49.53"
            width="72.54"
            height="3.93"
            rx="1.73"
            transform="translate(713.23 136.33) rotate(-174.65)"
            fill="#9ae1f8"
          />
          <path
            d="M385.18,55.88s2.44,9.17-.66,28.2c-3,18.65-13.32,28.54-11.42,46.8,1.93,18.55,3,35,3,35l-30.81-25.5-19.79,21.69s-13.27-25.53-12.17-43.37,10.65-26.64,16-46.42c2.69-10,1.47-21.61,1.47-21.61Z"
            fill="#d52bc8"
          />
          <path
            d="M385.16,51.88a2.67,2.67,0,0,0,0,4c-7.55-.67-18.55-1.69-18.55-1.69s-2.15-2.24.32-4C373,50.57,385.16,51.88,385.16,51.88Z"
            fill="#c22bc5"
          />
          <path
            d="M349,48.41a2.67,2.67,0,0,0,0,4c-7.55-.68-18.55-1.7-18.55-1.7s-2.15-2.24.31-4C336.86,47.09,349,48.41,349,48.41Z"
            fill="#c22bc5"
          />
          <path
            d="M357.8,23.58V35.19a4.62,4.62,0,0,0,2.85.61c.44,0,1.29-.25,1.73-.29V23.58L360.08,0Z"
            fill="#cfdff1"
          />
          <path
            d="M323.67,48.34l0-.46a1.74,1.74,0,0,1,1.89-1.57l.14,0c0,.07,0,.15,0,.23l-.05.46a1.75,1.75,0,0,0,1.57,1.89l68.63,6.43A1.74,1.74,0,0,1,394,56.67l-68.77-6.44A1.74,1.74,0,0,1,323.67,48.34Z"
            fill="#9ae1f8"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M360.08,0l-.49,5.07L361.24,22l.22,12.34a15.7,15.7,0,0,1-1.93.06,8.49,8.49,0,0,1-1.73-.31v1.1a4.62,4.62,0,0,0,2.85.61c.44,0,1.29-.25,1.73-.29V23.58Z"
            fill="#bad2f1"
          />
          <path
            d="M362.6,34.82c0,.58-1.12,1-2.5,1s-2.5-.47-2.5-1"
            fill="none"
            stroke="#cfdff1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M329.35,72.29c-.66,2.43-1.37,4.68-2.13,6.82,12.15-.11,32.41,5,42.17,5.83,13.7,1.14,18.83-23,15.79-29.06-5.94-.66-20.07-1.6-33.66-3.22l-20.7-2S332,62.29,329.35,72.29Z"
            fill="#c42bc8"
          />
          <path
            d="M325.54,162.08l19.79-21.69,30.81,25.5s-1.11-16.46-3-35a40.72,40.72,0,0,1-.21-5.45c-18.05,2.92-49,2.41-59.57-3.45C313.81,139.51,325.54,162.08,325.54,162.08Z"
            fill="#c42bc8"
          />
          <g>
            <path
              d="M318.57,108c-.66-.24-.87-.78-.63-1.59.2-.66.38-1.27.56-1.83a14.26,14.26,0,0,1,.53-1.47,1.8,1.8,0,0,1,.6-.85,1,1,0,0,1,.68-.16,9.69,9.69,0,0,1,1.15.27q1.92-3.59,3.92-7t3.81-6.46a2.46,2.46,0,0,1,1.58-1.27q.72-.07,1.47-.09a8.88,8.88,0,0,1,1.33.09l.63.11a4.39,4.39,0,0,1,.5.14c.5.15.79.63.86,1.43q.15,2.37.2,6.25t-.13,8.58l.66,0h.58c.5.07.7.48.62,1.22a13.1,13.1,0,0,1-.45,2.25l-.17.62a4.7,4.7,0,0,1-.24.65,2.56,2.56,0,0,1-.61,1,1.22,1.22,0,0,1-.77.29c-.05.6-.1,1.16-.15,1.69s-.1,1-.14,1.43-.07.52-.09.64a1.42,1.42,0,0,1-.07.28,1.44,1.44,0,0,1-1,1.14,12,12,0,0,1-1.75.35,6.75,6.75,0,0,1-1.74,0,.68.68,0,0,1-.61-.42,2.36,2.36,0,0,1-.08-1.06l.41-4.07c-1-.05-2-.15-3-.28-.64-.09-1.28-.19-1.91-.3s-1.24-.23-1.84-.36c-.34.72-.66,1.42-1,2.11s-.6,1.36-.89,2q-.54,1.29-1.41,1.17a6.41,6.41,0,0,1-1.56-.44,8,8,0,0,1-1.44-.75c-.38-.26-.48-.72-.29-1.36l.1-.27c0-.1.11-.28.22-.53l.66-1.45C318,109.18,318.27,108.6,318.57,108Zm7.72-4.88,2.13.3c.71.1,1.43.18,2.16.26.12-1.58.2-3.15.25-4.7s.06-3,0-4.44c-.83,1.49-1.61,2.94-2.36,4.36S327,101.73,326.29,103.12Z"
              fill="#60cff5"
            />
            <path
              d="M341.65,91.61a2.34,2.34,0,0,1,.75-1.29,3.06,3.06,0,0,1,1-.33,24.75,24.75,0,0,1,7.25.13,12.29,12.29,0,0,1,2.52.67,6.81,6.81,0,0,1,2,1.19,4.16,4.16,0,0,1,1.21,1.76,3.87,3.87,0,0,1,0,2.34,8.14,8.14,0,0,1-.85,2,9,9,0,0,1-1.3,1.71,11,11,0,0,1-1.65,1.39,16.92,16.92,0,0,1-1.89,1.14,5.73,5.73,0,0,1,1.76.84,4.27,4.27,0,0,1,1.24,1.37,4.5,4.5,0,0,1,.56,2,7.74,7.74,0,0,1-.3,2.55,10.94,10.94,0,0,1-1.58,3.43,11.57,11.57,0,0,1-2.56,2.66,10.24,10.24,0,0,1-3.24,1.61A8.87,8.87,0,0,1,343,117a19.42,19.42,0,0,1-2.07-.39,10,10,0,0,1-2-.7,1.69,1.69,0,0,1-.89-1,5.59,5.59,0,0,1,.14-2.53l.79-3.68c.25-1.15.51-2.27.78-3.35s.54-2.15.81-3.2.56-2.1.86-3.17l.67-2.38a2.11,2.11,0,0,1-.78.05c-.47-.07-.66-.51-.55-1.32a12.35,12.35,0,0,1,.22-1.31c.1-.45.21-.9.34-1.34l.15-.55C341.52,92,341.58,91.8,341.65,91.61ZM347,96c-.23.81-.44,1.61-.65,2.39s-.41,1.56-.61,2.36a11.44,11.44,0,0,0,3.51-1.56,8.09,8.09,0,0,0,2.26-2.15,4,4,0,0,0-2.3-.91,8.73,8.73,0,0,0-1.06-.09Zm2.29,12.1a1.43,1.43,0,0,0,0-.92,1.51,1.51,0,0,0-.52-.67,2.87,2.87,0,0,0-.91-.45,6,6,0,0,0-1.15-.26,9.93,9.93,0,0,0-2.17-.07l-1.06,4.53a4.65,4.65,0,0,0,.85.27,6.54,6.54,0,0,0,.8.15,4.07,4.07,0,0,0,2.67-.43A3.42,3.42,0,0,0,349.25,108.13Z"
              fill="#ffdc05"
            />
            <path
              d="M356.19,106.81a25.45,25.45,0,0,1,2.39-5.94A20,20,0,0,1,362,96.32a13.4,13.4,0,0,1,4-2.75,7.55,7.55,0,0,1,4.2-.6,8.27,8.27,0,0,1,1.83.5l.32-.62c.3-.61.65-.88,1-.82a3.05,3.05,0,0,1,1.06.46,5.41,5.41,0,0,1,1.14.92,1.35,1.35,0,0,1,.18,1.33,5.52,5.52,0,0,1-.18.54c-.29.73-.61,1.51-1,2.35s-.74,1.68-1.14,2.54-.78,1.7-1.17,2.53-.76,1.58-1.1,2.27a2.75,2.75,0,0,1-.56.85.78.78,0,0,1-.65.2l-.17,0a1.28,1.28,0,0,1-.3-.12,6.11,6.11,0,0,1-.71-.33A4,4,0,0,1,368,105a1,1,0,0,1-.39-.78,2.39,2.39,0,0,1,.05-.83,1.27,1.27,0,0,1,.07-.24c0-.08.11-.29.23-.63s.35-.87.62-1.52.57-1.34.88-2a1.37,1.37,0,0,0-.32-.11l-.39-.07a3.67,3.67,0,0,0-2,.32,7.2,7.2,0,0,0-2.1,1.4,10.77,10.77,0,0,0-1.89,2.38,12.74,12.74,0,0,0-1.35,3.27,11.2,11.2,0,0,0-.37,2.48,6.22,6.22,0,0,0,.27,2.1,3.62,3.62,0,0,0,.94,1.49,2.85,2.85,0,0,0,1.6.72,6.16,6.16,0,0,0,2.41-.19,13.77,13.77,0,0,0,2.53-.94,1.21,1.21,0,0,1,.65-.18c.2,0,.35.25.44.67a6.46,6.46,0,0,1,.18,1.83,7.9,7.9,0,0,1-.25,1.93,4.15,4.15,0,0,1-.34.91,2.11,2.11,0,0,1-.58.7,9.36,9.36,0,0,1-1.72,1,12.79,12.79,0,0,1-4,1.15,7.55,7.55,0,0,1-1.78,0,6.19,6.19,0,0,1-3-1.23,7,7,0,0,1-2.08-2.71,10.94,10.94,0,0,1-.84-4A17.86,17.86,0,0,1,356.19,106.81Z"
              fill="#8df51b"
            />
          </g>
        </g>
        <g transform="translate(140, 250)">
          <path
            fill="#FFFFFF"
            d="M3.5,11c0.8,0,1.5,0,2.1,0s1.1,0,1.3-0.1c0.4,0,0.7,0,0.9-0.1c0.3,0,0.5,0,0.5,0c0.3,0,0.5,0.1,0.6,0.2
            C9,11,9.1,11.2,9.2,11.5c0,0.2,0,0.3,0.1,0.4c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.4-0.2,0.5
            c-0.1,0.1-0.3,0.2-0.6,0.2c-0.8,0.1-1.5,0.1-2.2,0.2c-0.7,0-1.4,0.1-2.1,0.1c-0.5,0-1.1,0-1.6,0c-0.5,0-1.1,0-1.6-0.1
            c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5C0,11.9,0,10.7,0,9.5c0-1.4,0.1-2.9,0.2-4.3c0.1-1.4,0.2-2.9,0.4-4.4
            c0-0.3,0.1-0.5,0.3-0.7C1,0.1,1.3,0,1.6,0c0.3,0,0.7,0,1,0c0.3,0,0.6,0.1,0.9,0.1c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.1,0.3,0.1,0.4
            c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.4C3.9,2.8,3.8,4.1,3.7,5.6c-0.1,1.5-0.2,3-0.2,4.5V11z"
          />
          <path
            fill="#FFFFFF"
            d="M17.5,14c-0.4-0.1-0.6-0.1-0.6-0.3c-0.1-0.1-0.1-0.3-0.1-0.6c-0.4,0.3-0.9,0.6-1.3,0.8s-1,0.3-1.5,0.3
            c-0.6,0-1.2-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.8s-0.6-0.8-0.8-1.3c-0.2-0.5-0.3-1-0.3-1.6c0-0.8,0.2-1.6,0.5-2.3
            c0.3-0.7,0.7-1.3,1.2-1.8c0.5-0.5,1.1-0.9,1.7-1.2c0.6-0.3,1.3-0.4,2-0.4c0.6,0,1.1,0.1,1.7,0.3c0-0.2,0.1-0.4,0.2-0.5
            c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.5,0,0.9,0.1c0.4,0.1,0.7,0.1,1,0.2c0.2,0,0.3,0.1,0.4,0.1C20,4.6,20,4.6,20.1,4.7
            c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0,0.3,0,0.6c0,1.1,0,2.3-0.1,3.6s-0.2,2.5-0.3,3.6c-0.1,0.4-0.1,0.6-0.3,0.8
            c-0.1,0.2-0.4,0.3-0.7,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0S17.6,14,17.5,14z M16.9,10.3c0-0.5,0.1-1,0.1-1.5
            c0-0.5,0-1,0.1-1.5c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.1-0.7-0.1c-0.4,0-0.7,0.1-1,0.3C14.5,7.5,14.3,7.7,14,8
            c-0.2,0.3-0.4,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.2,0.8c0,0.5,0.1,0.9,0.4,1.1c0.3,0.3,0.7,0.4,1.2,0.4c0.3,0,0.6-0.1,0.9-0.2
            C16.3,10.8,16.6,10.6,16.9,10.3z"
          />
          <path
            fill="#FFFFFF"
            d="M22,5.6c0-0.3,0-0.5,0.1-0.7c0-0.2,0.2-0.3,0.4-0.4c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.6-0.1
            c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3
            c0.5-0.3,1-0.6,1.5-0.7c0.5-0.2,1.1-0.2,1.6-0.2c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.7,0.2,1,0.4c0.3,0.2,0.6,0.5,0.8,0.8
            c0.2,0.4,0.3,0.8,0.3,1.5c0,0.3,0,0.7,0,1.2c0,0.5,0,0.9-0.1,1.5c0,0.5-0.1,1.1-0.1,1.6C31,11.9,31,12.5,30.9,13
            c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.3,0.3-0.6,0.3c-0.2,0-0.4,0-0.7,0s-0.6-0.1-0.9-0.1c-0.4-0.1-0.6-0.4-0.6-0.8c0-0.1,0-0.3,0-0.5
            c0-0.2,0-0.5,0.1-0.8c0-0.4,0.1-0.8,0.1-1.3c0-0.5,0-1.2,0-2c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.5-0.3c-0.3,0-0.7,0.1-1,0.2
            c-0.4,0.1-0.7,0.3-1.1,0.6c0,0.8,0,1.6,0.1,2.4c0,0.8,0.1,1.6,0.2,2.4c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.2,0.5
            c-0.1,0.1-0.4,0.2-0.8,0.2c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0c-0.4,0-0.6-0.1-0.8-0.3
            c-0.1-0.2-0.2-0.4-0.2-0.7c-0.1-1-0.2-1.9-0.2-2.9c-0.1-1-0.1-2-0.1-3c0-0.2,0-0.5,0-0.7C21.9,6.1,22,5.9,22,5.6z"
          />
          <path
            fill="#FFFFFF"
            d="M41.9,16.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-0.9,0.5
            c-0.3,0.1-0.7,0.2-1.1,0.2c-0.9,0-1.7-0.1-2.4-0.2c-0.7-0.2-1.4-0.4-2.2-0.7c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.2-0.5
            c0-0.2,0.1-0.4,0.2-0.7c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.5,0.1
            c0.6,0.2,1.2,0.4,1.8,0.4c0.5,0.1,1.1,0.1,1.8,0.1c0.1-0.4,0.1-0.8,0.2-1.2c0.1-0.4,0.1-0.9,0.1-1.4c-0.8,0.7-1.8,1-2.9,1
            c-0.6,0-1.2-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.5-0.3-1-0.3-1.5c0-0.8,0.2-1.5,0.5-2.2
            C33,7.1,33.4,6.5,33.9,6c0.5-0.5,1.1-0.9,1.7-1.2c0.6-0.3,1.3-0.4,2-0.4c0.2,0,0.5,0,0.7,0c0.2,0,0.5,0.1,0.7,0.2
            c0-0.2,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.4,0,0.8,0.1c0.4,0.1,0.7,0.1,1.1,0.2c0.2,0,0.3,0.1,0.4,0.1
            c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.3,0.1,0.6c0,0.3,0,0.8,0.1,1.2c0,0.5,0,1,0,1.6c0,0.7,0,1.3,0,2.1
            c0,0.7,0,1.4-0.1,2.1c0,0.7-0.1,1.4-0.2,2C42.1,15.3,42,15.8,41.9,16.3z M39.1,10.2c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1V7.2
            C39,7.1,38.8,7.1,38.7,7c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0.1-1,0.2c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.2-0.4,0.5-0.5,0.8
            c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.5,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.2,0.4C38,10.9,38.6,10.7,39.1,10.2z"
          />
          <path
            fill="#FFFFFF"
            d="M53.2,12.6c0,0.3,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.3-0.4,0.4c-0.3,0.1-0.7,0.2-1.1,0.3c-0.4,0.1-0.7,0.1-1,0.1
            c-0.5,0-0.7-0.2-0.7-0.6c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c-0.5,0.3-0.9,0.6-1.5,0.7C47.8,14,47.3,14,46.7,14
            c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.7-0.2-1-0.4s-0.6-0.5-0.8-0.8c-0.2-0.4-0.3-0.8-0.3-1.5c0-0.3,0-0.7,0-1.2c0-0.5,0-0.9,0.1-1.5
            C43.9,8.1,44,7.6,44,7c0.1-0.6,0.1-1.1,0.2-1.7c0.1-0.4,0.2-0.6,0.4-0.7c0.2-0.1,0.5-0.2,0.9-0.2c0.2,0,0.4,0,0.6,0
            c0.2,0,0.4,0.1,0.6,0.1c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.4,0,0.7c0,0.3-0.1,0.7-0.1,1.1
            c0,0.4-0.1,0.9-0.1,1.4c0,0.5,0,1,0,1.5c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.7-0.1,1-0.2
            c0.4-0.1,0.7-0.3,1.1-0.6c0-0.6,0-1.1,0-1.7c0-0.5-0.1-1-0.1-1.5c0-0.4-0.1-0.8-0.1-1.1c0-0.3,0-0.5,0-0.6c0-0.3,0.1-0.4,0.2-0.6
            s0.4-0.3,0.8-0.4c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.6,0c0.4,0,0.6,0.1,0.8,0.2c0.2,0.1,0.3,0.3,0.3,0.7c0.1,0.9,0.2,1.9,0.2,2.9
            c0.1,1,0.1,2,0.1,3c0,0.2,0,0.5,0,0.7C53.2,12.2,53.2,12.4,53.2,12.6z"
          />
          <path
            fill="#FFFFFF"
            d="M61.8,14c-0.4-0.1-0.6-0.1-0.6-0.3c-0.1-0.1-0.1-0.3-0.1-0.6c-0.4,0.3-0.9,0.6-1.3,0.8s-1,0.3-1.5,0.3
            c-0.6,0-1.2-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.8c-0.3-0.4-0.6-0.8-0.8-1.3c-0.2-0.5-0.3-1-0.3-1.6c0-0.8,0.2-1.6,0.5-2.3
            s0.7-1.3,1.2-1.8c0.5-0.5,1.1-0.9,1.7-1.2c0.6-0.3,1.3-0.4,2-0.4c0.6,0,1.1,0.1,1.7,0.3c0-0.2,0.1-0.4,0.2-0.5
            c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.5,0,0.9,0.1c0.4,0.1,0.7,0.1,1,0.2c0.2,0,0.3,0.1,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2
            c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0,0.3,0,0.6c0,1.1,0,2.3-0.1,3.6s-0.2,2.5-0.3,3.6c-0.1,0.4-0.1,0.6-0.3,0.8
            c-0.1,0.2-0.4,0.3-0.7,0.3c-0.1,0-0.2,0-0.4,0s-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0S61.9,14,61.8,14z M61.2,10.3c0-0.5,0.1-1,0.1-1.5
            c0-0.5,0-1,0.1-1.5c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.1-0.7-0.1c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.5,0.4-0.7,0.6
            c-0.2,0.3-0.4,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.2,0.8c0,0.5,0.1,0.9,0.4,1.1s0.7,0.4,1.2,0.4c0.3,0,0.6-0.1,0.9-0.2
            C60.6,10.8,60.9,10.6,61.2,10.3z"
          />
          <path
            fill="#FFFFFF"
            d="M75.5,16.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-0.9,0.5
            c-0.3,0.1-0.7,0.2-1.1,0.2c-0.9,0-1.7-0.1-2.4-0.2c-0.7-0.2-1.4-0.4-2.2-0.7c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.2-0.5
            c0-0.2,0.1-0.4,0.2-0.7c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.3,0,0.5,0.1
            c0.6,0.2,1.2,0.4,1.8,0.4c0.5,0.1,1.1,0.1,1.8,0.1c0.1-0.4,0.1-0.8,0.2-1.2c0.1-0.4,0.1-0.9,0.1-1.4c-0.8,0.7-1.8,1-2.9,1
            c-0.6,0-1.2-0.1-1.6-0.3c-0.5-0.2-0.9-0.5-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.5-0.3-1-0.3-1.5c0-0.8,0.2-1.5,0.5-2.2
            C66.6,7.1,67,6.5,67.5,6c0.5-0.5,1.1-0.9,1.7-1.2c0.6-0.3,1.3-0.4,2-0.4c0.2,0,0.5,0,0.7,0c0.2,0,0.5,0.1,0.7,0.2
            c0-0.2,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0.2,0,0.4,0,0.8,0.1c0.4,0.1,0.7,0.1,1.1,0.2c0.2,0,0.3,0.1,0.4,0.1
            c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3s0.1,0.3,0.1,0.6c0,0.3,0,0.8,0.1,1.2c0,0.5,0,1,0,1.6c0,0.7,0,1.3,0,2.1
            c0,0.7,0,1.4-0.1,2.1c0,0.7-0.1,1.4-0.2,2C75.6,15.3,75.6,15.8,75.5,16.3z M72.7,10.2c0-0.4,0-0.8,0-1.1c0-0.4,0-0.7,0-1.1V7.2
            c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0.1-1,0.2c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.2-0.4,0.5-0.5,0.8
            c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.5,0.1,0.8,0.4,1.1c0.3,0.3,0.7,0.4,1.2,0.4C71.5,10.9,72.1,10.7,72.7,10.2z"
          />
          <path
            fill="#FFFFFF"
            d="M86.3,9.4c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-0.9,0.2-1.5,0.3c-0.5,0.1-1,0.1-1.6,0.2
            c-0.6,0.1-1.1,0.1-1.6,0.1c0.3,0.3,0.6,0.5,1,0.7c0.4,0.2,0.8,0.3,1.3,0.3c0.3,0,0.7,0,1.2-0.1c0.4-0.1,0.8-0.2,1.2-0.4
            c0.2-0.1,0.3-0.1,0.4-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0.1,0.3,0.1,0.4
            c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2c0,0.2-0.1,0.5-0.3,0.6c-0.4,0.4-0.9,0.7-1.6,0.9c-0.7,0.2-1.5,0.3-2.3,0.3c-0.6,0-1.2-0.1-1.8-0.3
            c-0.6-0.2-1.1-0.6-1.5-1c-0.4-0.4-0.8-0.9-1.1-1.5c-0.3-0.6-0.4-1.2-0.4-2c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.6-1.1,1.1-1.6
            c0.5-0.4,1-0.8,1.6-1c0.6-0.2,1.2-0.4,1.9-0.4c0.9,0,1.6,0.2,2.2,0.5c0.6,0.3,1.1,0.7,1.4,1.2c0.4,0.5,0.6,0.9,0.8,1.4
            c0.2,0.5,0.2,0.9,0.2,1.3c0,0.2,0,0.3-0.1,0.4C86.6,9.2,86.5,9.3,86.3,9.4z M82.2,7c-0.4,0-0.9,0.1-1.2,0.4c-0.4,0.3-0.6,0.6-0.8,1
            c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.7-0.3c-0.1-0.4-0.4-0.6-0.7-0.8C82.8,7,82.5,7,82.2,7z"
          />
          <path
            fill="#FFFFFF"
            d="M92.2,11.2c-0.5-0.1-0.8-0.3-0.8-0.7c0-0.3,0-0.6,0-0.9c0-0.3,0-0.5,0.1-0.7c0-0.2,0.1-0.4,0.2-0.4
            c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.4,0,0.9,0.1c0.4-1.2,0.8-2.5,1.3-3.7c0.5-1.2,0.9-2.4,1.4-3.4c0.2-0.4,0.5-0.7,0.9-0.7
            c0.3-0.1,0.7-0.1,1-0.2c0.4,0,0.7-0.1,1-0.1c0.2,0,0.3,0,0.5,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7,0.3,0.9,0.6c0.4,0.8,0.9,1.8,1.4,3.1
            c0.6,1.3,1.1,2.7,1.6,4.2c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0.4,0,0.6,0.2,0.7,0.6
            c0.1,0.3,0.1,0.7,0.1,1.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2
            c0.1,0.3,0.2,0.6,0.2,0.8c0.1,0.3,0.1,0.5,0.2,0.7c0,0.2,0.1,0.3,0.1,0.3c0,0.1,0,0.1,0,0.1c0,0.3-0.2,0.5-0.5,0.6
            c-0.4,0.1-0.8,0.2-1.2,0.3c-0.4,0.1-0.8,0.1-1.2,0.1c-0.2,0-0.4-0.1-0.5-0.2s-0.2-0.3-0.3-0.5l-0.5-2c-0.7,0-1.4,0.1-2.2,0.1
            c-0.5,0-0.9,0-1.4,0c-0.5,0-0.9,0-1.4-0.1c-0.1,0.4-0.2,0.7-0.2,1.1c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.4-0.3,0.6-0.7,0.6
            c-0.3,0-0.7,0-1.2-0.1c-0.4-0.1-0.8-0.2-1.1-0.3c-0.3-0.1-0.5-0.3-0.5-0.6c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.3
            c0-0.2,0.1-0.4,0.2-0.7C92.1,11.8,92.2,11.5,92.2,11.2z M96.6,8.4c0.5,0,1,0,1.6,0s1,0,1.6,0C99.5,7.6,99.3,6.8,99,6
            c-0.3-0.8-0.6-1.5-0.9-2.2c-0.3,0.8-0.5,1.5-0.8,2.3C97.1,6.9,96.8,7.6,96.6,8.4z"
          />
          <path
            fill="#FFFFFF"
            d="M106.1,5.6c0-0.3,0-0.5,0.1-0.7c0-0.2,0.2-0.3,0.4-0.4c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.6-0.1
            c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3
            c0.4-0.3,0.8-0.6,1.2-0.8c0.4-0.2,0.9-0.3,1.4-0.3c0.3,0,0.6,0.1,0.8,0.4c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.6,0.1,1
            c0,0.3,0,0.6,0,0.9c0,0.3-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.4-0.7,0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.3,0.1-0.5,0.1-0.6,0.1
            c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0-0.3,0-0.6c0-0.2,0-0.4-0.1-0.6c-0.2,0.1-0.3,0.2-0.5,0.3
            c-0.1,0.1-0.3,0.2-0.5,0.4c0,0.7,0,1.3,0,1.9c0,0.6,0.1,1.1,0.1,1.6c0,0.5,0.1,0.8,0.1,1.2c0,0.3,0,0.5,0,0.6
            c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.4,0.2-0.8,0.2c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0
            c-0.4,0-0.6-0.1-0.8-0.3c-0.1-0.2-0.2-0.4-0.2-0.7c-0.1-1-0.2-1.9-0.2-2.9s-0.1-2-0.1-3c0-0.2,0-0.5,0-0.7
            C106.1,6.1,106.1,5.9,106.1,5.6z"
          />
          <path
            fill="#FFFFFF"
            d="M113.8,6.2c0-0.2,0-0.4,0-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.2,0,0.4-0.1,0.6-0.1V4.6
            c0-0.2,0-0.5,0-0.7s0-0.5,0-0.8c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.4-0.2,0.8-0.2c0.3-0.1,0.8-0.1,1.4-0.1
            c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.4,0.2,0.6c0,0.1,0,0.2,0,0.4c0,0.2,0,0.4,0,0.6c0,0.2,0,0.5,0,0.8c0,0.3,0,0.5,0,0.7
            c0.2,0,0.4,0,0.7,0.1c0.2,0,0.4,0,0.7,0.1c0.3,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6c0,0.1,0,0.3,0,0.5c0,0.2,0,0.4-0.1,0.6
            c-0.1,0.3-0.1,0.4-0.3,0.5c-0.1,0.1-0.3,0.2-0.6,0.2c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.3,0-0.4,0c0,0.4,0,0.9,0.1,1.4
            c0,0.5,0.1,1.1,0.1,1.6c0,0.5,0.1,1,0.1,1.4c0,0.4,0,0.7,0,0.8c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.3,0.2-0.5,0.2
            c-0.5,0.1-1,0.1-1.4,0.1c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6c-0.1-0.9-0.2-1.8-0.3-2.7c-0.1-0.9-0.2-1.8-0.2-2.7
            l-0.5-0.1c-0.3,0-0.5-0.1-0.6-0.2c-0.1-0.1-0.2-0.3-0.2-0.6c0-0.1,0-0.3,0-0.4C113.8,6.4,113.8,6.3,113.8,6.2z"
          />
          <path
            fill="#FFFFFF"
            d="M128.2,11.2c0,0.4-0.1,0.8-0.3,1.2c-0.2,0.3-0.5,0.6-0.9,0.9c-0.4,0.2-0.8,0.4-1.3,0.6
            c-0.5,0.1-1.1,0.2-1.7,0.2c-0.5,0-1,0-1.4-0.1c-0.4-0.1-0.8-0.2-1.2-0.3c-0.3-0.1-0.5-0.3-0.5-0.6c0-0.1,0-0.2,0.1-0.4
            c0.1-0.2,0.1-0.4,0.2-0.6s0.2-0.4,0.2-0.6c0.1-0.3,0.3-0.4,0.4-0.4c0.1,0,0.3,0.1,0.5,0.2c0.2,0.1,0.5,0.2,0.7,0.2
            c0.3,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0,0.7-0.1c0.2-0.1,0.3-0.2,0.3-0.4c0-0.1-0.1-0.3-0.3-0.4c-0.2-0.1-0.4-0.2-0.7-0.4
            c-0.3-0.1-0.6-0.3-0.9-0.4c-0.3-0.2-0.7-0.4-0.9-0.6c-0.3-0.2-0.5-0.5-0.7-0.9c-0.2-0.3-0.3-0.7-0.3-1.2c0-0.5,0.1-0.9,0.4-1.2
            c0.2-0.4,0.6-0.7,1-0.9c0.4-0.3,0.9-0.5,1.4-0.6c0.5-0.1,1-0.2,1.6-0.2c0.5,0,0.9,0,1.4,0.1c0.5,0.1,0.9,0.2,1.3,0.3
            c0.2,0.1,0.4,0.2,0.5,0.3s0.2,0.3,0.2,0.6c0,0.3,0,0.6-0.1,0.9c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0.2-0.1,0.3-0.2,0.4
            s-0.3,0.2-0.5,0.2c-0.4,0-0.8,0-1.1-0.1c-0.3-0.1-0.4-0.1-0.5-0.2c-0.1-0.1-0.1-0.3-0.1-0.6V6.9c-0.3-0.1-0.5-0.1-0.6-0.1
            c-0.3,0-0.6,0-0.8,0.1c-0.2,0.1-0.3,0.2-0.3,0.5c0,0.1,0.1,0.3,0.3,0.4c0.2,0.1,0.5,0.2,0.8,0.4c0.3,0.1,0.7,0.3,1.1,0.4
            c0.4,0.2,0.7,0.4,1.1,0.6c0.3,0.2,0.6,0.5,0.8,0.9C128.1,10.3,128.2,10.7,128.2,11.2z"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(47, 86)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default LanguageArtsLink;
